'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12(evaluator$14) {
  this.M2 = null;
  this.M2 = evaluator$14;
}
export { $c_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12 as $c_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12 };
$p = $c_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12;
/** @constructor */
function $h_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12() {
}
export { $h_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12 as $h_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12 };
$h_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.M2.h();
  return ($j_java$002elang$002e$002dObject.$isInt(v) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12, "samples.Sealed$package$$anon$6$$anon$8$$anon$12", ({
  qE: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12 as $d_Lsamples_Sealed$package$$anon$6$$anon$8$$anon$12 };
